import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { IPBoardPartAbbreviation } from 'src/app/model/product/ip-board/ip-board-part-abbreviation';
import {
  UrbanPlanningAbbreviation,
  URBAN_PLANNING_ABBREVIATION_OPTIONS_ARRAY
} from 'src/app/model/product/ip-board/urban-planning-abbreviation';

export class IPBoardPartAbbreviationSelectorHelper {
  private constructor() {}

  static initializeAbbreviationSelectStates(
    existingAbbreviations: IPBoardPartAbbreviation[]
  ): AbbrevationSelectState[] {
    const toReturn = this.initializeNoneSelectedStates();

    if (!CollectionHelper.isPopulated(existingAbbreviations)) {
      return toReturn;
    }

    const lookup = new Map<number, AbbrevationSelectState>(
      toReturn.map(s => [s.abbreviation.ordinal, s])
    );

    existingAbbreviations.forEach(a => {
      const state = lookup.get(a.abbreviation.ordinal);
      if (state != null) {
        state.selected = true;
        state.existingIPBoardPartAbbreviation = a;
      }
    });

    return toReturn;
  }

  private static initializeNoneSelectedStates(): AbbrevationSelectState[] {
    return URBAN_PLANNING_ABBREVIATION_OPTIONS_ARRAY.map(a => {
      return {
        abbreviation: a,
        selected: false,
        existingIPBoardPartAbbreviation: null
      };
    });
  }
}

export interface AbbrevationSelectState {
  abbreviation: UrbanPlanningAbbreviation;
  selected: boolean;
  existingIPBoardPartAbbreviation: IPBoardPartAbbreviation;
}
